import Skeleton from "react-loading-skeleton";
import {
  PodcastSkeleton,
  MainPodcastsListWrapper as StyledMainPodcastsListWrapper,
  PodcastSkeletons,
} from "./styled";
import { PodcastsListMain } from "../PodcastsListMain/PodcastsListMain";

export const MainPodcastsListWrapper = ({ podcasts, isLoading }) => {
  return (
    <StyledMainPodcastsListWrapper columns={podcasts?.length}>
      {isLoading ? (
        <PodcastSkeletons>
          {Array.from({ length: 4 }).map((_, index) => (
            <PodcastSkeleton as={Skeleton} key={index} />
          ))}
        </PodcastSkeletons>
      ) : (
        <PodcastsListMain podcasts={podcasts} />
      )}
    </StyledMainPodcastsListWrapper>
  );
};
